export const serialize = <T>(json: T) => JSON.stringify(json)
export const deserialize = <T>(value: string): T => {
  if (typeof value !== 'string') {
    return value as unknown as T
  }
  return JSON.parse(value)
}
